export default "__VITE_ASSET__DS_Wmw8J__"